import { useLayoutEffect,useState } from 'react';

function useWindowSize() {
    //Store the window values somewhere 
    const [size, setSize] = useState([0, 0]);

    //Similar to useEffect but fires in sync after every DOM mutation
    //Useful to rerender an component on window resize
    useLayoutEffect(() => {
      //Update state
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      //Add event listener on window fired upon resize
      window.addEventListener('resize', updateSize);
      //To set the inital values
      updateSize();
      //Cleanup function to remove the event listener on unmount
      return () => window.removeEventListener('resize', updateSize);
    }, []);

    //Return the size to use in compoents
    return size;
  }

export default useWindowSize;